<template>
    <div class="container">


    	<!-- Choose Send Method -->
    	<div v-if="step == 'send_method'" class="pt-3">
                        
            <b-form-group label-cols-sm="2" label-align-sm="right" label="Send this deck to:">
              <b-button variant="primary" @click="goToStep('choose_contact')" value="single" title="Send to a Single Recipient">A Single Recipient</b-button>

              <b-button v-if="!loaded_mailinglists"
              	variant="primary" 
              	@click="showNoty('warning','Loading Mailing Lists. Please wait...',2000)" 
              	value="campaign"
				title="Loading Mailing Lists. Please wait..."
				:disabled=true
          		>Loading Mailing Lists...</b-button> 
              <b-button v-if="loaded_mailinglists && mailinglists.length == 0"
              	variant="primary" 
              	@click="showNoty('warning','Looks like you don\'t have any Mailing Lists setup. <a href=\'/contacts/mailinglist/new\'>Click here</a> to add one.')" 
              	value="campaign"
				title="You need to upload at least one Mailing List to use this feature" 
          		>Multiple Recipients</b-button> 
              <b-button v-if="loaded_mailinglists && mailinglists.length > 0"
              	variant="primary" 
              	@click="goToStep('choose_mailinglist')" 
              	value="campaign"
				title="Send to a Mailing List" 
          		>Multiple Recipients</b-button> 

              or 
              <b-button variant="primary" @click="goToStep('show_link')" title="Share a link">Share a link</b-button>
            </b-form-group>            

        </div>

        <!-- Choose Contact (Single Send) -->
        <div v-if="step == 'choose_contact'">

			<b-tabs content-class="mt-3">
				<b-tab class="pb-3" title="Choose Existing Contact" active>
				  <bootstrap-table-deck-send-contacts @selectContact="selectContact"></bootstrap-table-deck-send-contacts>
				</b-tab>
				<b-tab title="Add a New Contact">

					<b-form @submit="addContact">
						<b-form-group label-cols-sm="2" label="First Name:" label-align-sm="right" label-for="first-name">
							<b-form-input  
								v-model="addcontactform.first_name"
								id="first-name"
							></b-form-input>
						</b-form-group>
						<b-form-group label-cols-sm="2" label="Last Name:" label-align-sm="right" label-for="last-name">
							<b-form-input 
								v-model="addcontactform.last_name"
								id="last-name"  
							></b-form-input>
						</b-form-group>
						<b-form-group label-cols-sm="2" label="Company Name:" label-align-sm="right" label-for="company-name">
							<b-form-input 
								v-model="addcontactform.company_name"
								id="company-name" 								
							></b-form-input>
						</b-form-group>
						<b-form-group label-cols-sm="2" label="Email Address:" label-align-sm="right" label-for="email">
							<b-form-input 
								v-model="addcontactform.email" 
								id="email"
								type="email"
								></b-form-input>
						</b-form-group>
						<b-form-group label-cols-sm="2" label="Mobile Number:" label-align-sm="right" label-for="phone">
							<vue-tel-input 
								v-model="addcontactform.telephone" 
								placeholder="" 
								mode="international"
							></vue-tel-input>
						</b-form-group>      

						<b-button variant="primary" class="float-right" type="submit">Add Contact</b-button>
					</b-form>

				</b-tab>
				<b-tab v-if="use_capsule" class="pb-3" title="Select Capsule Contact">
				    <bootstrap-table-deck-send-capsule-contacts @selectCapsuleContact="selectCapsuleContact"></bootstrap-table-deck-send-capsule-contacts>
				</b-tab>
			</b-tabs>
			<b-button variant="secondary" @click="goToStep('send_method')">Back</b-button>
       	</div>

       	<!-- Choose Mailing Lists -->
        <div v-if="step == 'choose_mailinglist'">

			<b-form-group label="Select Mailing List(s) you wish to send to:">
			<b-form-checkbox
				v-for="mailinglist in mailinglists"
				v-model="selected_mailinglists"
				:key="mailinglist.id"
				:value="mailinglist.id"
				name="mailinglists[]">
				{{ mailinglist.name }} ({{ mailinglist.size_minus_suppressed }})
			</b-form-checkbox>
			</b-form-group>

			<b-button variant="secondary" @click="goToStep('send_method')">Back</b-button>
			<b-button variant="primary" class="float-right" @click="selectMailingLists()">Next</b-button>
        </div>
       	<!-- Send Via -->
       	<div v-if="step == 'send_via'">

			<b-form-group label-cols-sm="2" label-align-sm="right" label="Send this deck via:">

			  <b-button 
			  	variant="primary" 
			  	@click="selectSendVia('both')" 
			  	v-bind:disabled="(send_method == 'single' && (!contact.email || !contact.telephone) )" 
			  	v-bind:title="(send_method == 'single' && (!contact.email || !contact.telephone) ) ? 'Not available as contact does not have both an email address and mobile number' : 'Send via Email and SMS'" 
			  >Email and SMS</b-button>

			  <b-button 
			  	variant="primary" 
			  	@click="selectSendVia('email')"
			  	v-bind:disabled="(send_method == 'single' && !contact.email)" 
			  	v-bind:title="(send_method == 'single' && !contact.email) ? 'Not available as contact does not have an email address' : 'Send via Email Only'" 
			  >Email Only</b-button>

			  <b-button
			  	variant="primary" 
			  	@click="selectSendVia('sms')"
			  	v-bind:disabled="(send_method == 'single' && !contact.telephone )" 
			  	v-bind:title="(send_method == 'single' && !contact.telephone ) ? 'Not available as contact does not have a mobile number' : 'Send via SMS Only'" 
			  >SMS Only</b-button>

			  <b-button
			  	variant="primary" 
			  	@click="goToStep('show_contact_link')"
			  	v-if="send_method == 'single'" 
			  >Share Link</b-button>

			</b-form-group>
			<div>              
              <b-button v-if="send_method == 'single'" variant="secondary" @click="goToStep('choose_contact')">Back</b-button>
              <b-button v-if="send_method == 'campaign'" variant="secondary" @click="goToStep('choose_mailinglist')">Back</b-button>
			</div>
       	</div>

       	<!-- Compose SMS -->
       	<div v-if="step == 'compose_sms'">

            <b-form-group label="SMS Message">
                <b-input type="text" v-model="sms.message"></b-input>
                <div><small class="text-muted">{{ 'This is the accompanying text message your recipient will see when they receive your SizzleDeck on their mobile phone. Sending this SMS will use '+ Math.ceil(sms.message.length / 120)*parseInt(sms_credit_value) +' credit' }}<span v-if="parseInt(sms_credit_value) > 1">s</span><span v-if="send_method == 'campaign'"> per recipient</span>.</small></div>
            </b-form-group>
			
			<div>
				<b-button variant="secondary" @click="goToStep('send_via')">Back</b-button>

				<b-button variant="primary" class="float-right" @click="saveSMS()">Next</b-button>
            </div>
       	</div>

       	<!-- Compose Email -->
       	<div v-if="step == 'compose_email'">

			<b-form-group label="Email Subject">
			  <b-input type="text" v-model="email.subject"></b-input>
			</b-form-group>

			<b-form-group label="Email Message">
			  <b-form-textarea type="text" v-model="email.body"></b-form-textarea>
			</b-form-group>

			<b-form-group label="Button Text">
			  <b-input type="text" v-model="email.button"></b-input>
			</b-form-group>

			<b-form-group label="Email Footer">
			  <b-form-textarea type="text" v-model="email.footer"></b-form-textarea>
			</b-form-group>

			<div class="mb-3"><small class="text-muted">{{ 'This is the accompanying email message your recipient will see when they receive your SizzleDeck. Sending this email will use '+ parseInt(email_credit_value) +' credit' }}<span v-if="parseInt(email_credit_value) > 1">s</span><span v-if="send_method == 'campaign'"> per recipient</span>.</small></div>

			<div>
			  <b-button v-show="send_via === 'both'" variant="secondary" @click="goToStep('compose_sms')">Back</b-button>
			  <b-button v-show="send_via === 'email'" variant="secondary" @click="goToStep('send_via')">Back</b-button>

			  <b-button variant="primary" class="float-right"  @click="saveEmail()">Next</b-button>
			</div>

       	</div>

        <!-- Display Link -->
        <div v-if="step == 'show_link'">
            
              <b-form-group label="Link" description="This is the link to your SizzleDeck. You can share this link via email, social media or however you like. After this SizzleDeck has been published, this link will be available in the results area.">
              	<b-input-group>
					<b-input readonly type="text" v-model="link"></b-input>
					<b-input-group-append>
						<copy-to-clipboard :text="link" @copy="copyLink"><b-button variant="outline-secondary" style="border-top-left-radius: 0;border-bottom-left-radius: 0;"><i class="fa fa-copy"></i> Copy Link</b-button></copy-to-clipboard>
					</b-input-group-append>
				</b-input-group>
              </b-form-group>

              <div>
              	<b-button variant="secondary" @click="goToStep('send_method')">Back</b-button>
              	<b-button variant="primary" class="float-right" @click="shareLink()">Publish and Enable Tracking</b-button>
              </div>
            
        </div>
        <div v-if="step == 'show_contact_link'">
            
              <b-form-group label="Link" description="This is the link to your SizzleDeck. You can share this link via email, social media or however you like. After this SizzleDeck has been published, this link will be available in the results area.">
				<b-input-group>
					<b-input readonly type="text" v-model="contactlink"></b-input>
					<b-input-group-append>
						<copy-to-clipboard :text="contactlink" @copy="copyLink"><b-button variant="outline-secondary" style="border-top-left-radius: 0;border-bottom-left-radius: 0;"><i class="fa fa-copy"></i> Copy Link</b-button></copy-to-clipboard>
					</b-input-group-append>
				</b-input-group>

              </b-form-group>

              <div>
              	<b-button variant="secondary" @click="goToStep('send_via')">Back</b-button>
              	<b-button variant="primary" class="float-right" @click="shareContactLink()">Publish and Enable Tracking</b-button>
              </div>
            
        </div>

        <!-- Preview -->
		<div v-if="step == 'preview'">

			<div class="text-center">
				<b-button variant="secondary" v-if="send_method === 'campaign'" :href="'/deck/preview/'+this.deckid" target="_blank">Preview Deck</b-button> 
				<b-button variant="secondary" v-if="send_method === 'single'" :href="'/deck/preview/'+this.deckid+'/'+this.contact_id" target="_blank">Preview Deck</b-button> 
				<b-button variant="secondary" v-if="send_via === 'both' || send_via === 'sms'" @click="previewSMS()">Preview SMS</b-button> 
				<b-button variant="secondary" v-if="send_via === 'both' || send_via === 'email'" @click="previewEmail()">Preview Email</b-button>
			</div>

			<div class="text-center">
				<b-button variant="primary" class="float-right" @click="scheduleSend()">Send Deck</b-button>
			</div>

			<div>
				<b-button v-show="send_via === 'both'" variant="secondary" @click="goToStep('compose_email')">Back</b-button>
				<b-button v-show="send_via === 'sms'" variant="secondary" @click="goToStep('compose_sms')">Back</b-button>
			  	<b-button v-show="send_via === 'email'" variant="secondary" @click="goToStep('compose_email')">Back</b-button>
			</div>

		</div>

		<b-modal id="sms-modal" size="lg" hide-footer title="SMS Preview">
			<div class="d-block" v-html="sms.preview"></div>
		</b-modal>
		<b-modal id="email-modal" size="lg" hide-footer :title="'Email Preview - Subject: '+email.preview_subject">
			<div class="d-block" v-html="email.preview"></div>
		</b-modal>


    </div>
</template>

<script>

import axios from 'axios';
import Noty from 'noty';
import CopyToClipboard from 'vue-copy-to-clipboard';

export default {
	components: {
    	CopyToClipboard
  	},
    mounted() {
    	var vm = this;
    	// Get Share Link
		axios.post('/deck/getlink',{id: vm.deckid}).then(response => { vm.link = response.data; }).catch(function(error){ vm.handleError(error) });
    	
    	// Get Existing Details
    	axios.post('/deck/get',{id: vm.deckid}).then(response => {

			vm.sms.message = response.data.sms_message;
			vm.email.subject = response.data.email_subject;
			vm.email.body = response.data.email_body;
			vm.email.button = response.data.email_button;
			vm.email.footer = response.data.email_footer;

			// Get Defaults
			axios.get('/deck/defaults/').then(response => {

				if(vm.sms.message == null){ vm.sms.message = 'Hi [firstname], great chatting earlier. Here is some more info about '+response.data.company_name+' as discussed:'; }
				if(vm.email.subject == null){ vm.email.subject = 'More Info for [firstname]'; }
				if(vm.email.body == null){ vm.email.body = 'Hi [firstname], \r\rGreat chatting. Here is some more info about '+response.data.company_name+' as discussed.'; }
				if(vm.email.button == null){ vm.email.button = 'Click to View'; }
				if(vm.email.footer == null){ 
					vm.email.footer = 'Any questions, just let me know.\r\rKind regards,\r\r'+response.data.first_name+' '+response.data.last_name+'\r';
					if(response.data.position){vm.email.footer = vm.email.footer+'\r'+response.data.position;}
					vm.email.footer = vm.email.footer+'\r'+response.data.company_name; 
				}

				vm.use_capsule = response.data.use_capsule;

			}).catch(function(error){ vm.handleError(error) });

        }).catch(function(error){ vm.handleError(error) });

    	// Get Mailinglists
        axios.get('/contacts/mailinglist/list').then(response => {

          	vm.mailinglists = response.data.rows;

          	// Remove Empty Lists
            vm.mailinglists = vm.mailinglists.filter(function( mailinglist ) {
			    return mailinglist.size !== 0;
			});

            vm.$forceUpdate();
            vm.loaded_mailinglists = true;

        }).catch(function(error){ vm.handleError(error) });


    },
    props: [
        'deckid',
        'sms_credit_value',
        'email_credit_value',
    ],
    computed:{
    	contactlink: function(){ return this.link + '/' + this.contact_id; }
    },
    data: function(){
        return {                
        	step: 'send_method',
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            send_method: null,
            send_via: null,
            link: null,
            addcontactform: {
				email: '',
				telephone: '',
				first_name: '',
				last_name: '',
				company_name: '',
			},
			contact_id: null,
			contact: {
				email: '',
				telephone: '',
				first_name: '',
				last_name: '',
				company_name: '',
			},
			use_capsule: false,
			loaded_mailinglists:false,
			mailinglists:[],
            selected_mailinglists:[],
			sms: {
				message:'',
				preview: '',
			},
			email:{
				subject: '',
				body: '',
				button: '',
				footer: '',
				preview: '',
				preview_subject: '',
			}
        };
    },
    methods:{
    	goToStep: function(step){
    		this.step = step;
    	},
    	shareLink: function(){
              
              var vm = this;

              axios.post('/deck/marksent',{id: vm.deckid}).then(response => {

               window.location.href = '/deck/results';

              }).catch(function(error){ vm.handleError(error) });

        },
        copyLink: function(result){
        	if(result){
        		this.showNoty('success','Link Copied to Clipboard',1000);
        	}
        },
    	shareContactLink: function(){
              
              var vm = this;

              axios.post('/deck/marksent',{id:vm.deckid,send_type:'contact_share',contact_id:vm.contact_id}).then(response => {

               window.location.href = '/deck/results';

              }).catch(function(error){ vm.handleError(error) });

        },
        addContact: function(evt){

        	var vm = this;

			evt.preventDefault();
			var post = this.addcontactform;
			post.ajax = true;

			axios.post('/contacts/contact/store',post).then(response => {

				if(response.data.status == 'success'){
					vm.selectContact(response.data.contact_id);
				}else{
					new Noty({
	                  text: response.data.message,
	                  type: 'error',
	                  theme: 'bootstrap-v4',
	                  layout: 'topCenter',
	                  timeout: 2000
	              	}).show();
				}

			}).catch(function(error){ vm.handleError(error) });

        },
        selectCapsuleContact: function(capsule_id){
        	var vm = this;
        	
        	axios.get('/contact/lookup/capsule/'+capsule_id).then(response => {

        		if(response.data.status == 'success'){
        			vm.contact_id = response.data.contact.id;
        			vm.contact = response.data.contact;
        			vm.send_method = 'single';
        			vm.step = 'send_via';
        		}else{
        			new Noty({
	                  text: response.data.message,
	                  type: 'error',
	                  theme: 'bootstrap-v4',
	                  layout: 'topCenter',
	                  timeout: 4000
	              	}).show();
        		}

        	}).catch(function(error){ vm.handleError(error) });
        },
        selectContact: function(id){
        	var vm = this;
        	vm.contact_id = id;
        	axios.get('/contact/lookup/id/'+id).then(response => {

        		if(response.data.status == 'success'){
        			vm.contact = response.data.contact;
        			vm.send_method = 'single';
        			vm.step = 'send_via';
        		}else{
        			new Noty({
	                  text: response.data.message,
	                  type: 'error',
	                  theme: 'bootstrap-v4',
	                  layout: 'topCenter',
	                  timeout: 4000
	              	}).show();
        		}

        	}).catch(function(error){ vm.handleError(error) });
        },
        selectMailingLists: function(){
        	var vm = this;
        	if(vm.selected_mailinglists.length == 0){
    	        	new Noty({
                      text: 'Please select one or more Mailing Lists to continue.',
                      type: 'error',
                      theme: 'bootstrap-v4',
                      layout: 'topCenter',
                      timeout: 2000
                    }).show();
    	        	return;
    	    }
              
            vm.send_method = 'campaign';
            vm.step = 'send_via';
        },
        selectSendVia: function(method){
        	var vm = this;
        	vm.send_via = method;

        	switch(method){
        		case 'email':
        			vm.step = 'compose_email';
        		break
        		case 'sms':
        			vm.step = 'compose_sms';
        		break
        		case 'both':
        			vm.step = 'compose_sms';
        		break
        	}

       
        },
        saveSMS: function(){
        	
        	var vm = this;
        	axios.post('/deck/store',{
                id: vm.deckid,
                sms_message: vm.sms.message,
              }).then(response => {

              	if(response.data.status == 'success'){

              		if(vm.send_via == 'sms'){
              			vm.goToStep('preview');
              		}else{
              			vm.goToStep('compose_email');
              		}
                  

                }else{

                    new Noty({
                        text: response.data.message,
                        type: 'error',
                        theme: 'bootstrap-v4',
                        layout: 'topCenter',
                        timeout: 2000
                    }).show();

                }

              }).catch(function(error){ vm.handleError(error) });

        },
        previewSMS: function(){

              var vm = this;

              axios.post('/deck/sms-preview',{deck_id:vm.deckid,send_type:vm.send_method,contact_id:vm.contact_id,mailinglists:vm.selected_mailinglists}).then(response => {

                vm.sms.preview = response.data.sms_message;

                vm.$nextTick(function () {
  					vm.$bvModal.show('sms-modal');
				});

              }).catch(function(error){ vm.handleError(error) });

        },
        saveEmail: function(){

        	var vm = this;
        	axios.post('/deck/store',{
                id: vm.deckid,
                  email_subject: vm.email.subject,
                  email_body: vm.email.body,
                  email_button: vm.email.button,
                  email_footer: vm.email.footer
              }).then(response => {

              	if(response.data.status == 'success'){

                  vm.goToStep('preview');

                }else{

                    new Noty({
                        text: response.data.message,
                        type: 'error',
                        theme: 'bootstrap-v4',
                        layout: 'topCenter',
                        timeout: 2000
                    }).show();

                }

              }).catch(function(error){ vm.handleError(error) });

        },
        previewEmail: function(){

              var vm = this;

              axios.post('/deck/email-preview',{deck_id:vm.deckid,send_type:vm.send_method,contact_id:vm.contact_id,mailinglists:vm.selected_mailinglists}).then(response => {

                vm.email.preview = response.data.email_message;
                vm.email.preview_subject = response.data.email_subject;

                vm.$nextTick(function () {
  					vm.$bvModal.show('email-modal');
				});

                

              }).catch(function(error){ vm.handleError(error) });

        },
        scheduleSend: function(){

              	var vm = this;

              	if(vm.send_method == 'single'){
              		var post_vars = {
              				id : vm.deckid,
              				type : 'single',
              				via : vm.send_via,
              				contact_id : vm.contact_id
              			};
              	}
              	if(vm.send_method == 'campaign'){
              		var post_vars = {
              				id : vm.deckid,
              				type : 'bulk',
              				via : vm.send_via,
              				mailinglists : vm.selected_mailinglists
              			};
              	}

                axios.post('/deck/send',post_vars).then(response => {

                      if(response.data.status == 'success'){

                          window.location.href = '/deck/results';
                      
                      }else{

                          new Noty({
                              text: response.data.message,
                              type: response.data.status,
                              theme: 'bootstrap-v4',
                              layout: 'topCenter',
                              timeout: false
                          }).show();

                      }

                  }).catch(function(error){ vm.handleError(error) });

        },
        handleError: function(error){

            if(error.response.status == '419'){
              this.showLoggedOutNoty();
            }else{
              this.showGeneralErrorNoty();
          	}

        },
        showNoty: function(type='warning',message='',timeout=false){
	        new Noty({
	                  text: message,
	                  type: type,
	                  theme: 'bootstrap-v4',
	                  layout: 'topCenter',
	                  timeout: timeout
	              }).show();
        },
        showGeneralErrorNoty: function(){
	        new Noty({
	                  text: 'There has been an error. Please <a href="javascript:window.location.reload(true)">refresh this page</a> and try again.',
	                  type: 'error',
	                  theme: 'bootstrap-v4',
	                  layout: 'topCenter',
	                  timeout: false
	              }).show();
        },
        showLoggedOutNoty: function(){
        	new Noty({
	            text: 'You have been logged out due to inactivity. Please <a href="javascript:window.location.reload(true)">refresh this page</a> to login.',
	            type: 'error',
	            theme: 'bootstrap-v4',
	            layout: 'topCenter',
	            timeout: false
	        }).show();
        },            
    }
}

</script>